import {FC} from 'react';
import styled from 'styled-components';
import {useParams} from 'wouter';

import {Flex} from '@shared_web/components/core2/flex';

import {HEADER_HEIGHT} from '@mavismart_frontend/lib/constants';
import {NotificationPage} from '@mavismart_frontend/pages/notification_page';
import {NotificationTabs} from '@mavismart_frontend/pages/notification_tabs';
import {UserAccount} from '@mavismart_frontend/pages/user_account';

// Unified desktop page that keeps side lists mounted across route changes to preserve scroll
export const MobileAccount: FC = () => {
  const {page, notificationId} = useParams<{page?: string; notificationId?: string}>();
  if (page === 'account') {
    return (
      <Wrapper $column $gap="m">
        <UserAccount />
      </Wrapper>
    );
  }
  if (page === 'notifications' || page === 'settings') {
    return notificationId ? <NotificationPage /> : <NotificationTabs />;
  }
  return <></>;
};
MobileAccount.displayName = 'MobileHome';

const Wrapper = styled(Flex)`
  margin-top: calc(${HEADER_HEIGHT}px + env(safe-area-inset-top));
`;
